@if (showLoader()) {
  <section class="loaderwrp">
    <div class="scale-loader">
      <div class="dot-pulse"></div>
    </div>
  </section>
}

<div class="px24-700">
  <div class="mb44 mb28-700">
    @for (ppQuestion of questions; track ppQuestion) {
      @for (key of (allData | keyvalue); track key) {
        @if (key.key===ppQuestion.mappingField && ppQuestion.mappingField === 'interestedIDPSerivce' && key.value?.length) {
          <div class="mb12 mb8-700">
            <p class="font-bold mb4">{{ ppQuestion.label}}</p>
            <p>
              @for (item of key.value; track item; let i = $index; let last = $last) {
                {{ item.option_label }}@if (!last) {
                <span>, </span>
              }
            }
          </p>
        </div>
      }
    }
  }
</div>

<div class="mb44 mb28-700">
  <p class="ques-hd sub-head">{{personalDetailsText}}</p>
  <div class="flex gap8 items-start mb12 mb8-700">
    @for (ppQuestion of questions; track ppQuestion) {
      @for (key of (allData | keyvalue); track key) {
        @if (key.key===ppQuestion.mappingField && (ppQuestion.mappingField === 'first_name' || ppQuestion.mappingField === 'last_name') && key.value?.option_label) {
          <div class="flex items-center gap8 flex-1 flex-col-300">
            @if (ppQuestion.mappingField === 'first_name') {
              <div class="flex-1">
                <p class="font-bold mb4">{{ ppQuestion.label}}</p>
                <p>{{ key.value.option_label }}</p>
              </div>
            }
            @if (ppQuestion.mappingField === 'last_name') {
              <div class="flex-1">
                <p class="font-bold mb4">{{ ppQuestion.label}}</p>
                <p>{{ key.value.option_label }}</p>
              </div>
            }
          </div>
        }
      }
    }
  </div>

  @for (ppQuestion of questions; track ppQuestion) {
    @for (key of (allData | keyvalue); track key) {
      @if (key.key===ppQuestion.mappingField && (
        ppQuestion.mappingField === 'date_of_birth' || ppQuestion.mappingField === 'primary_mobile_number'
        ) && (key.value?.option_label || this.phoneNumber)) {
        <div class="mb12 mb8-700">
          <p class="font-bold mb4">{{ ppQuestion.label}}</p>
          @if ((ppQuestion.mappingField === 'date_of_birth')) {
            <p>{{ key.value.option_label }}</p>
          }
          @if ((ppQuestion.mappingField === 'primary_mobile_number')) {
            <p>{{ this.phoneNumber }}</p>
          }
        </div>
      }
    }
  }

  <div class="flex gap8 items-start">
    @for (ppQuestion of questions; track ppQuestion) {
      @for (key of (allData | keyvalue); track key) {
        @if (key.key===ppQuestion.mappingField && (ppQuestion.mappingField === 'maritalStatus' || ppQuestion.mappingField === 'gender') && key.value?.option_label) {
          <div class="flex items-center gap8 flex-1 mb12 mb8-700 flex-col-300">
            @if (ppQuestion.mappingField === 'gender') {
              <div class="flex-1">
                <p class="font-bold mb4">{{ ppQuestion.label}}</p>
                <p>{{ key.value.option_label }}</p>
              </div>
            }
            @if (ppQuestion.mappingField === 'maritalStatus') {
              <div class="flex-1">
                <p class="font-bold mb4">{{ ppQuestion.label}}</p>
                <p>{{ key.value.option_label }}</p>
              </div>
            }
          </div>
        }
      }
    }
  </div>

  @for (ppQuestion of questions; track ppQuestion) {
    @for (key of (allData | keyvalue); track key) {
      @if (key.key===ppQuestion.mappingField && (ppQuestion.mappingField === 'passport'
        || ppQuestion.mappingField === 'nationalityCode' || ppQuestion.mappingField === 'preferredStudyLevel'
        || ppQuestion.mappingField === 'studyPlanTimeline' || ppQuestion.mappingField === 'preferredCountryCode'
        || ppQuestion.mappingField === 'primaryFinancialSource' || ppQuestion.mappingField === 'howDidYouHear'
        ) && key.value?.option_label) {
        <div class="mb12 mb8-700">
          <p class="font-bold mb4">{{ ppQuestion.label}}</p>
          <p>{{ key.value.option_label }}</p>
        </div>
      }
    }
  }
</div>

<div class="mb44 mb28-700">
  <p class="ques-hd sub-head">{{academicDetailsText}}</p>
  <div class="flex gap8 flex-column items-start mb12 mb8-700">
    @for (ppQuestion of questions; track ppQuestion) {
      @for (key of (allData | keyvalue); track key) {
        @if (key.key===ppQuestion.mappingField && (ppQuestion.mappingField === 'studyCountryName'
          || (ppQuestion.mappingField === 'institutionName' && ppQuestion.displayFormat.value === 'SELECT_BOX') || ppQuestion.mappingField === 'qualificationType'
          || ppQuestion.mappingField === 'examBoardName'
          || ppQuestion.mappingField === 'studyMode' || ppQuestion.mappingField === 'studyStartDate' || ppQuestion.mappingField === 'studyEndDate'
          || ppQuestion.mappingField === 'studyDuration' || ppQuestion.mappingField === 'studyLanguageName' || ppQuestion.mappingField === 'studyStatus' || ppQuestion.mappingField === 'gradeType' || ppQuestion.mappingField === 'grade'
          || ppQuestion.mappingField === 'qualificationTitle' || ppQuestion.mappingField === 'finalGrade') && (key.value.option_label || key.value)) {
          <div class="mb12 mb8-700">
            <p class="font-bold mb4">{{ ppQuestion.label}}</p>
            <p>{{ key.value.option_label || key.value }}</p>
          </div>
        }
        <!-- Major Subjects -->
        @if (key.key===ppQuestion.mappingField && ppQuestion.mappingField === 'majorSubjects' && key.value) {
          <div class="mb12 mb8-700">
            <p class="font-bold mb4">{{ ppQuestion.label}}</p>
            @if (key.value[0]?.option_label) {
              <p>{{ key.value[0].option_label }}</p>
            }
            @if (!key.value[0]?.option_label && key.value.option_label) {
              <p>{{ key.value.option_label }}</p>
            }
          </div>
        }
        <!-- Other Institution Name -->
        @if (key.key==='other_institutionName' && ppQuestion.mappingField === 'institutionName' && ppQuestion.displayFormat.value === 'TEXT_BOX' && (key.value?.option_value || key.value)) {
          <div class="mb12 mb8-700">
            <p class="font-bold mb4">{{ ppQuestion.label}}</p>
            <p>{{ key.value?.option_value || key.value }}</p>
          </div>
        }
        <!-- Is Honours Degree -->
        @if (key.key==='isHonoursDegree' && ppQuestion.mappingField === 'isHonoursDegree' && key.value !== null && key.value !== undefined) {
          <div class="mb12 mb8-700">
            <p class="font-bold mb4">{{ ppQuestion.label}}</p>
            <p>{{ key.value === true ? (ppQuestion.options?.[0]?.option_label || 'Yes') : (ppQuestion.options?.[1]?.option_label || 'No') }}</p>
          </div>
        }
        <!-- Number of Backlogs (rendered after honours) -->
        @if (key.key==='isHonoursDegree' && ppQuestion.mappingField === 'isHonoursDegree') {
          @if (getBacklogsQuestionForReview() && getUserInputValue('numberOfBacklogsOrRetakes')) {
            <div class="mb12 mb8-700">
              <p class="font-bold mb4">{{ getBacklogsQuestionForReview()?.label }}</p>
              <p>{{ getUserInputValue('numberOfBacklogsOrRetakes') }}</p>
            </div>
          }
          @if (getBacklogsLast2YearsQuestionForReview() && getUserInputValue('numberOfBacklogsRetakesInLast2Years')) {
            <div class="mb12 mb8-700">
              <p class="font-bold mb4">{{ getBacklogsLast2YearsQuestionForReview()?.label }}</p>
              <p>{{ getUserInputValue('numberOfBacklogsRetakesInLast2Years') }}</p>
            </div>
          }
        }
        <!-- Applicable Grade / Pass Score (render only for first matching applicableGrade question) -->
        @if (key.key==='applicableGrade' && ppQuestion.mappingField === 'applicableGrade' && isFirstApplicableGradeQuestion(ppQuestion) && (key.value?.option_label || key.value)) {
          <div class="mb12 mb8-700">
            <p class="font-bold mb4">{{ ppQuestion.label}}</p>
            <p>{{ key.value?.option_label || key.value }}</p>
          </div>
        }
      }
    }

    <!-- Academic test details -->

    @for (ppQuestion of questions; track ppQuestion) {
      @for (key of (allData | keyvalue); track key) {
        @if (key.key==='academic_' + ppQuestion.mappingField && (ppQuestion.mappingField === 'testType' && ppQuestion.questionAttributeId === 2326) && key.value.option_label) {
          <div class="mb12 mb8-700">
            <p class="font-bold mb4">{{ ppQuestion.label}}</p>
            <p>{{ key.value.option_label }}</p>
          </div>
        }
        @if (key.key==='academic_' + ppQuestion.mappingField && (ppQuestion.mappingField === 'testTakenDate' && ppQuestion.questionAttributeId === 2337) && (key.value?.option_value || key.value?.option_label || key.value)) {
          <div class="mb12 mb8-700">
            <p class="font-bold mb4">{{ ppQuestion.label}}</p>
            <p>{{ key.value?.option_value || key.value?.option_label || key.value }}</p>
          </div>
        }
        @if (key.key==='academic_' + ppQuestion.mappingField && (ppQuestion.mappingField === 'overallScore' && ppQuestion.questionAttributeId === 2336) && (key.value?.option_value || key.value?.option_label || key.value)) {
          <div class="mb12 mb8-700">
            <p class="font-bold mb4">{{ ppQuestion.label}}</p>
            <p>{{ key.value?.option_value || key.value?.option_label || key.value }}</p>
          </div>
        }
      }
    }
  </div>
</div>

<div class="mb44 mb28-700">
  <p class="ques-hd sub-head">{{englishProficiencyDetailsText}}</p>
  @for (ppQuestion of questions; track ppQuestion) {
    @for (key of (allData | keyvalue); track key) {
      @if (key.key===ppQuestion.mappingField && ppQuestion.mappingField === 'englishIsFirstLanguage' && key.value?.option_label) {
        <div class="mb12 mb8-700">
          <p class="font-bold mb4">{{ ppQuestion.label}}</p>
          <p>{{ key.value.option_label }}</p>
        </div>
      }
    }
  }

  <!-- English test details - only show when englishIsFirstLanguage is not Yes -->
  @if (allData['englishIsFirstLanguage']?.option_value?.toLowerCase() !== 'yes') {
    @for (ppQuestion of questions; track ppQuestion) {
      @for (key of (allData | keyvalue); track key) {
        @if (key.key==='english_' + ppQuestion.mappingField && (ppQuestion.mappingField === 'testType' && ppQuestion.questionAttributeId === 2294) && key.value.option_label) {
          <div class="mb12 mb8-700">
            <p class="font-bold mb4">{{ ppQuestion.label}}</p>
            <p>{{ key.value.option_label }}</p>
          </div>
        }
        <!-- Other English Test Type -->
        @if (key.key==='other_english_testType' && ppQuestion.mappingField === 'testType' && ppQuestion.questionAttributeId === 2294 && isEnglishTestTypeOthers() && (key.value?.option_value || key.value)) {
          <div class="mb12 mb8-700">
            <p class="font-bold mb4">{{otherTestNameText}}</p>
            <p>{{ key.value?.option_value || key.value }}</p>
          </div>
        }
        @if (key.key==='english_' + ppQuestion.mappingField && (ppQuestion.mappingField === 'testTakenDate' && ppQuestion.questionAttributeId === 2305) && (key.value?.option_value || key.value?.option_label || key.value)) {
          <div class="mb12 mb8-700">
            <p class="font-bold mb4">{{ ppQuestion.label}}</p>
            <p>{{ key.value?.option_value || key.value?.option_label || key.value }}</p>
          </div>
        }
        @if (key.key==='english_' + ppQuestion.mappingField && (ppQuestion.mappingField === 'overallScore' && ppQuestion.questionAttributeId === 2320) && (key.value?.option_value || key.value?.option_label || key.value)) {
          <div class="mb12 mb8-700">
            <p class="font-bold mb4">{{ ppQuestion.label}}</p>
            <p>{{ key.value?.option_value || key.value?.option_label || key.value }}</p>
          </div>
        }
      }
    }
  }
</div>

<!-- Checkbox consents -->
<div class="mb44 mb28-700">
  @for (ppQuestion of questions; track ppQuestion) {
    @if (ppQuestion.displayFormat.value === 'CHECKBOX') {
      <div class="mb16">
        <mat-checkbox
          [checked]="getCheckboxValue(ppQuestion.mappingField)"
          (change)="onCheckboxChange(ppQuestion.mappingField, $event)"
          color="primary"
          class="consent-checkbox">
          @if (!ppQuestion.termsURL && !ppQuestion.privacyURL) {
            <span class="consent-text">{{ ppQuestion.label }}@if (ppQuestion.mandatory === false) {
              <span class="optional-text"> (Optional)</span>
            }</span>
          }
          @if (ppQuestion.termsURL || ppQuestion.privacyURL) {
            <span class="consent-text" [innerHTML]="getConsentLabel(ppQuestion)"></span>
          }
        </mat-checkbox>
      </div>
      @if (ppQuestion.mandatory && !getCheckboxValue(ppQuestion.mappingField) && submitted) {
        <div class="reg-err mb8">
          {{ppQuestion.helpText}}
        </div>
      }
    }
  }
</div>

<div class="primary-btn-cnr flex gap12 mt44 mt28-700">
  <button class="secondary-btn" (click)="backButton ()">{{backText}}</button>
  <button class="primary-btn" (click)="submitRegistrationForm ()">{{submitText}}</button>
</div>
</div>

<button class="scroll-top-btn flex items-center justify-center" [class.visible]="showScrollBtnRev" [class.scrolling]="isScrollingRev" [disabled]="isScrollingRev" (click)="scrollToTop()" aria-label="Scroll to top">
  <img src="./assets/icons/arrow-up-icon.svg" alt="Go to top arrow icon" width="24" height="24" />
</button>
